import { css } from "@emotion/react";

export const GameFavouriteCardStyle = {
  self: css`
    padding: 9px 0 4px;
    max-width: 160px;
    height: 220px;
    width: 100%;
    position: relative;
    text-align: center;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    border: 1px solid #c5cee0;
    border-radius: 10px;
    vertical-align: top;
    z-index: 0;
    cursor: pointer;
    &::before {
      content: "";
      position: absolute;
      top: 9px;
      left: 9px;
      width: 140px;
      height: 140px;
      z-index: 1;
      background-repeat: no-repeat;
      background-position: center center;
    }
    img {
      position: relative;
      display: inline-block;
      width: 140px;
      height: 140px;
      vertical-align: middle;
    }

    &:hover {
      color: #232324;
      background: #737579;
      &::before {
        content: "";
        position: absolute;
        top: 9px;
        width: 100%;
        height: 140px;
        left: 0;
        z-index: 1;
        background: rgba(0, 0, 0, 0.7);
      }
      .btn-login-game {
        display: inline-block;
      }
    }
  `,

  nameWrapper: css`
    width: 100%;
    display: flex;
    gap: 4px;
    text-align: left;
    padding: 9px 10px 4px;
  `,

  name: css`
    flex: 1;
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  `,

  iconHeart: css`
    width: 16px;
    height: 20px;
    fill: #d00;
  `,

  provider: css`
    border: 0;
    color: #bfbfbf;
    margin: 0;
    padding: 0;
    font-size: 12px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: auto;
  `,

  btnLoginGame: css`
    color: #fff !important;
    background-color: #322825 !important;
    padding: 10px 20px;
    font-size: 14px;
    border: none !important;
    outline: none !important;
    width: unset !important;
    height: unset !important;
    transition: none;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    display: none;
  `,
};
